import visaLogo from '../../../../../../../../images/creditCardsLogos/Visa.png'
import discoverLogo from '../../../../../../../../images/creditCardsLogos/Discover.png'
import amexLogo from '../../../../../../../../images/creditCardsLogos/Amex.png'
import masterCardLogo from '../../../../../../../../images/creditCardsLogos/MC.png'
import unsupportedLogo from '../../../../../../../../images/creditCardsLogos/unsupported.png'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateCardLogo = (cardType) => {
  switch (cardType) {
    case 'visa':
      return visaLogo
    case 'discover':
      return discoverLogo
    case 'americanexpress':
      return amexLogo
    case 'mastercard':
      return masterCardLogo
    case null:
      return discoverLogo
    default:
      return unsupportedLogo
  }
}

export const makeCorrectExpiryDateString = (expiryString = '') => {
  const expirySplitedArr = expiryString.split('-')
  // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
  const correctExpiryString = [expirySplitedArr[1], expirySplitedArr[0].slice(-2)].join('/')
  return correctExpiryString
}
export const makeCorrectCardNumberString = (cardNumberString = '') => `...${cardNumberString?.slice(-4)}`
